import React from "react";
import {
    IProtocolStepDefinition,
    IGroupStepDefinition,
    TProtocolDefinitionId,
    TProtocolStepDefinitionId,
} from "../../types/protocolDefinitions";
import {IProtocolStepKind} from "../../types/protocol"
import cx from "clsx";
import classes from "./StepContentView.module.css";
import {GroupStepListView} from "./GroupStepListView";
import {PlanningStepView} from "./PlanningStepView.tsx";
import {DeepPartial} from "@/utils/types/DeepPartial";

interface StepContentViewProps {
    protocolId: TProtocolDefinitionId,
    step: IProtocolStepDefinition,
    allSteps?: Array<IProtocolStepDefinition>,
    onChange: (stepId: TProtocolStepDefinitionId, updates: DeepPartial<IProtocolStepDefinition>) => void,
    onAddStepToGroup?: (kind: IProtocolStepKind, name: string) => void,
    onDeleteStepFromGroup?: (step: IProtocolStepDefinition) => void,
    onGroupMemberOrderChanged?: (group: IGroupStepDefinition, newMemberStepIds: Array<TProtocolStepDefinitionId>) => void,
}

export const StepContentView: React.FC<StepContentViewProps> = ({
                                                                    step,
                                                                    allSteps = [],
                                                                    onChange,
                                                                    onAddStepToGroup,
                                                                    onDeleteStepFromGroup,
                                                                    onGroupMemberOrderChanged,
                                                                }: StepContentViewProps) => {
    // Handle GROUP step specially - render GroupStepListView
    if (step.kind === IProtocolStepKind.GROUP) {
        const groupStep = step as IGroupStepDefinition;
        return (
            <div className={cx(classes.groupRoot)}>
                <GroupStepListView
                    group={groupStep}
                    allSteps={allSteps}
                    onStepChange={(stepId, updates) => onChange(stepId, updates)}
                    onAddStep={onAddStepToGroup || (() => {})}
                    onDeleteStep={onDeleteStepFromGroup || (() => {})}
                    onMemberOrderChanged={onGroupMemberOrderChanged || (() => {})}
                    style={{flex: 1, minHeight: 0}}
                />
            </div>
        );
    }

    // Find the index of this step in allSteps for display
    const stepIndex = allSteps.findIndex(s => s.id === step.id);

    return (
        <div className={cx(classes.root)}>
            <PlanningStepView
                step={step}
                index={stepIndex >= 0 ? stepIndex : 0}
                onChange={(updates) => onChange(step.id, updates)}
            />
        </div>
    );
};